<template>
  <div class="flex items-center space-x-1">
    <button class="toolbar-btn"
            :class="{ 'active': editor.isActive('bulletList') }"
            @click="editor.chain().focus().toggleBulletList().run()"
            :title="$t('BulletList')">
      <i class="fas fa-list"></i>
    </button>
    <button class="toolbar-btn"
            :class="{ 'active': editor.isActive('orderedList') }"
            @click="editor.chain().focus().toggleOrderedList().run()"
            :title="$t('NumberedList')">
      <i class="fas fa-list-ol"></i>
    </button>
    <button class="toolbar-btn"
            @click="$emit('add-custom-html')"
            title="Custom HTML">
      <i class="fas fa-box"></i>
    </button>
    <button class="toolbar-btn"
            @click="$emit('open-st-list')"
            title="Open Step Templates List">
      <i class="fas fa-table-list"></i>
    </button>
    <vs-dropdown>
      <button class="toolbar-btn" :title="$t('ManualSteps')">
        <i class="fas fa-hand"></i>
      </button>
      <vs-dropdown-menu>
        <vs-dropdown-item v-for="type in stepTypes"
                          :key="type.value"
                          @click="$emit('add-manual-step', type.value)">
          {{ $t(type.labelKey) }} {{ $t('Step').toLowerCase() }}
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  name: 'ListButtons',
  props: {
    editor: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      stepTypes: [
        { label: 'Default manual', value: 'default' },
        { label: 'Warning', value: 'warning' },
        { label: 'Error', value: 'error' },
        { label: 'Success', value: 'success' },
        { label: 'Informational', value: 'informational' },
        { label: 'Code', value: 'code' },
        { label: 'Camera picture', value: 'camera' },
        { label: 'Assign SOP', value: 'assign-sop' },
        { label: 'Form Capture', value: 'form-capture' },
        { labelKey: 'DefaultManual', value: 'default' },
        { labelKey: 'Warning', value: 'warning' },
        { labelKey: 'Error', value: 'error' },
        { labelKey: 'Success', value: 'success' },
        { labelKey: 'Informational', value: 'informational' },
        { labelKey: 'Code', value: 'code' },
        { labelKey: 'CameraPicture', value: 'camera' }
      ]
    }
  }
}
</script> 
